var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlayBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2825)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#879196"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 458,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 458,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814,
    y: 458,
    width: 210,
    height: 458,
    transform: "rotate(-180 814 458)",
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 814,
    y: 458,
    width: 200,
    height: 458,
    transform: "rotate(-180 814 458)",
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 498,
    width: 200,
    height: 458,
    rx: 4,
    transform: "rotate(-90 178 498)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 814,
    height: 458,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 245,
    y: 97,
    width: 340,
    height: 280,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 89,
    width: 340,
    height: 280,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 113,
    width: 233,
    height: 24,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 313,
    width: 96,
    height: 32,
    rx: 8,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 316,
    width: 90,
    height: 26,
    rx: 5,
    stroke: "#4DA3D4",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 173,
    width: 292,
    height: 12,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 193,
    width: 292,
    height: 12,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 213,
    width: 292,
    height: 12,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 233,
    width: 292,
    height: 12,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 253,
    width: 292,
    height: 12,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 273,
    width: 188,
    height: 12,
    fill: "#B3D7EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayBanner);
export default __webpack_public_path__ + "static/media/overlay-banner.9dceac81800ef472e27e1609496ed3f2.svg";
export { ForwardRef as ReactComponent };